const welcome = {
    title: 'Welcome to Hytch Auth',
    description: 'Hytch Auth is a web app to manage authentication without coding requirements. Let’s first create an account. With this account, you can manage Hytch Auth by yourself or on behalf of your company.',
    create_account: 'Create account',
};
export default Object.freeze(welcome);
